module.exports = __webpack_public_path__ + "media/images/photo-newsletter-63a300cb5bdf863228ea226a13d705a9.jpg";